<template>
  <div>
    <DialogNewPlayer
          title="Se detectó un posible DNI extranjero"
          text="Se recomienda realizar una búsqueda por pasaporte para verificar la existencia del jugador en el sistema."
          ref="newPlayerDialogRef"
          :searchAlsoByDni="searchAlsoByDni"
        ></DialogNewPlayer>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title v-if="cuerpoTecnico" class="toolbar-title">{{ (isEditing) ? 'Edición de' : 'Nuevo' }} miembro del cuerpo técnico</v-toolbar-title>
      <v-toolbar-title v-else class="toolbar-title">{{ (isEditing) ? 'Edición de' : 'Nuevo' }} jugador</v-toolbar-title>
    </v-toolbar>
    <v-card v-if="loading" class="spacing-top">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </v-card>
    <v-card v-else-if="!(isEditing || confirmedDNI || confirmedPasaporte)" class="spacing-top">
      <p v-if="cuerpoTecnico" style="padding-left: 15px; padding-top: 15px;">- Ingrese el <b>DNI</b> o <b>pasaporte</b> en caso de que el miembro del cuerpo técnico no cuente con DNI argentino.</p>
      <p v-if="!cuerpoTecnico" style="padding-left: 15px; padding-top: 15px;">- Ingrese el <b>DNI</b> o <b>pasaporte</b> en caso de que el jugador no cuente con DNI argentino.</p>
      <v-layout row>
      <v-flex xs12 px-3>
        <v-text-field v-model="dni" :error-messages="dniErrors" label="DNI" append-icon="search"
                      @input="$v.dni.$touch()" @click:append="fetchPlayerByDNI()" :loading="loadingDNI"></v-text-field>
      </v-flex>
      </v-layout>
      <v-layout row>
      <v-flex xs12 px-3>
        <v-text-field v-model="pasaporte" :error-messages="pasaporteErrors" label="Pasaporte" append-icon="search"
                      @input="$v.pasaporte.$touch()" @click:append="fetchPlayerByPasaporte()" :loading="loadingPasaporte"></v-text-field>
      </v-flex>
      </v-layout>
      <v-btn style="margin-top: 10px;" color="grey" :disabled="saving" @click="newMethodToGoBack()">Volver</v-btn>
    </v-card>
    <v-card v-else class="spacing-top">
      <v-layout row>
        <v-flex xs3 v-if="photo" class="content-photo">
          <v-img :src="photo" max-height="230px" contain class="photo" v-show="!files.length"></v-img>
          <AttachFile ref="fileInput" @upload="uploadFiles" photo singleFile class="photo-button pa-1" v-show="files.length"></AttachFile>
        </v-flex>
        <v-flex xs3 class="content-photo" v-else>
          <v-btn class="photo-button" @click="openFileDirectory">
            <v-icon large v-if="!files.length">add_a_photo</v-icon>
            <AttachFile ref="fileInput" @upload="uploadFiles" photo singleFile class="photo-button pa-1" v-show="files.length"></AttachFile>
          </v-btn>
        </v-flex>
        <v-flex xs9>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field v-model="firstName" :error-messages="firstNameErrors" label="Nombre" required
                              :readonly="!canEdit" @input="$v.firstName.$touch()"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="lastName" :error-messages="lastNameErrors" label="Apellido" required
                              :readonly="!canEdit" @input="$v.lastName.$touch()"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="dni" :error-messages="dniErrors" label="DNI" :required="!this.pasaporte" :readonly="!canEdit"
                              @input="$v.dni.$touch()" v-if="isEditing"></v-text-field>
                <v-text-field v-model="dni" :error-messages="dniErrors" label="DNI" :required="!this.pasaporte" :readonly="confirmedDNI"
                              @input="$v.dni.$touch()" :append-icon="this.dni ? 'edit' : null"  @click:append="editDNI()" v-else></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="pasaporte" :error-messages="pasaporteErrors" label="Pasaporte" :required="!this.dni" :readonly="!canEdit"
                              @input="$v.pasaporte.$touch()" v-if="isEditing"></v-text-field>
                <v-text-field v-model="pasaporte" :error-messages="pasaporteErrors" label="Pasaporte" :required="!this.pasaporte" :readonly="confirmedPasaporte"
                              @input="$v.pasaporte.$touch()" :append-icon="this.pasaporte ? 'edit' : null"  @click:append="editPasaporte()" v-else></v-text-field>
              </v-flex>
              <v-flex :xs4="cuerpoTecnico ? true : false" :xs6="cuerpoTecnico ? false : true" pr-2>
                <v-autocomplete v-model="country" :items="countryItems" :error-messages="countryErrors" label="Nacionalidad" required
                          item-text="name" item-value="code" :readonly="!canEdit"
                          @change="$v.country.$touch()" no-data-text="No hay datos disponibles"></v-autocomplete>
              </v-flex>
              <v-flex :xs4="cuerpoTecnico ? true : false" :xs6="cuerpoTecnico ? false : true" pl-2>
                <DatePickerForm v-model="dateOfBirth" label="Fecha de nacimiento" :error-messages="dateOfBirthErrors"
                                :readonly="!canEdit"></DatePickerForm>
              </v-flex>
              <v-flex xs4 pl-2 v-if="cuerpoTecnico">
                <v-autocomplete v-model="rol" :items="roles" :error-messages="rolErrors" label="Rol" required
                          item-text="text" item-value="value" :readonly="!canEdit"
                          @change="$v.rol.$touch()" no-data-text="No hay datos disponibles"></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-divider class="my-2"></v-divider>
            <ConfirmationDialog :function-yes="bindingFunction" ref="confirm" title="Abandonar página"
                                text="Se perderán los cambios del formulario actual, ¿desea continuar?"></ConfirmationDialog>
            <v-card-actions>
              <v-btn color="grey" :disabled="saving" @click="goBackConfirmation">Volver</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="openFileDirectory" v-if="photo && canEdit" color="primary" :disabled="saving">Cambiar foto</v-btn>
              <v-btn @click="submit" color="primary" :disabled="saving">{{ (isEditing) ? 'Enviar' : 'Crear' }}</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import DatePickerForm from '../../../common/ui/DatePickerForm'
import AttachFile from '../../../common/ui/AttachFile'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import DialogNewPlayer from './DialogNewPlayer.vue'

const DIRECTOR_TECNICO = 0
const AYUDANTE_CAMPO = 1
const PREPARADOR_FISICO = 2
const ENTRENADOR_ARQUEROS = 3

export default {
  mixins: [validationMixin, createEntityMixin],
  props: {
    createPath: String,
    editPath: String,
    cuerpoTecnico: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    firstName: { required },
    lastName: { required },
    dni: { required: requiredIf(function () { return this.dni }) },
    country: { required },
    dateOfBirth: { required },
    rol: { required: requiredIf(function () { return this.cuerpoTecnico }) },
    pasaporte: { required: requiredIf(function () { return this.pasaporte }) }
  },

  components: {
    DatePickerForm,
    AttachFile,
    ConfirmationDialog,
    DialogNewPlayer
  },

  data () {
    return {
      loadingOptions: false,
      firstName: '',
      lastName: '',
      dni: '',
      country: '',
      countryItems: [],
      dateOfBirth: null,
      photo: null,
      canEdit: true,
      confirmedDNI: false,
      loadingDNI: false,
      rol: null,
      roles: [
        {
          text: 'Director Técnico',
          value: DIRECTOR_TECNICO
        },
        {
          text: 'Ayudante de Campo',
          value: AYUDANTE_CAMPO
        },
        {
          text: 'Preparador Físico',
          value: PREPARADOR_FISICO
        },
        {
          text: 'Entrenador de Arqueros',
          value: ENTRENADOR_ARQUEROS
        }
      ],
      pasaporte: '',
      confirmedPasaporte: false,
      loadingPasaporte: false
    }
  },

  computed: {
    isEditing () {
      return this.$route.params.hasOwnProperty('id')
    },
    firstNameErrors () {
      return this.getRequiredErrors('firstName')
    },
    lastNameErrors () {
      return this.getRequiredErrors('lastName')
    },
    dniErrors () {
      let errors = this.getRequiredErrors('dni')
      if (!this.$v.dni.$dirty) return errors
      !this.dniIsValid() && errors.push('DNI inválido. Sólo se permiten letras y números.')
      return errors
    },
    countryErrors () {
      return this.getRequiredErrors('country')
    },
    rolErrors () {
      return this.getRequiredErrors('rol')
    },
    dateOfBirthErrors () {
      let errors = this.getRequiredErrors('dateOfBirth')
      if (!this.dateOfBirth) return errors
      !this.dateOfBirthIsValid() && errors.push('Fecha de nacimiento inválida')
      return errors
    },
    pasaporteErrors () {
      let errors = this.getRequiredErrors('pasaporte')
      if (!this.$v.pasaporte.$dirty) return errors
      !this.pasaporteIsValid() && errors.push('Pasaporte inválido. Sólo se permiten letras y números.')
      return errors
    }
  },

  methods: {
    fetchCountryOptions () {
      this.loadingOptions = true
      this.axios
        .get('countries')
        .then(response => {
          this.countryItems = response.data
          this.loadingOptions = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    getPayload () {
      let payload = new FormData()
      payload.append('first_name', this.firstName)
      payload.append('last_name', this.lastName)
      payload.append('dni', this.dni)
      payload.append('date_of_birth', this.dateOfBirth)
      payload.append('country', this.country)
      if (this.files.length) {
        payload.append('photo', this.files[0], this.files[0].name)
      }
      if (this.cuerpoTecnico) {
        payload.append('rol', this.rol)
      }
      payload.append('pasaporte', this.pasaporte)
      return payload
    },
    setData (data) {
      this.firstName = data.firstName
      this.lastName = data.lastName
      this.dni = data.dni
      this.dateOfBirth = this.formatDate(data.dateOfBirth)
      this.photo = data.photo
      this.country = data.country.code
      this.canEdit = data.canEdit
      this.rol = data.rol
      this.pasaporte = data.pasaporte
    },
    isValidForm () {
      return !this.$v.$invalid && (this.dniIsValid() || this.pasaporteIsValid()) && this.dateOfBirthIsValid()
    },
    dniIsValid () {
      let rule = /^[a-zA-Z0-9]*$/
      return rule.test(this.dni)
    },
    pasaporteIsValid () {
      let rule = /^[a-zA-Z0-9]*$/
      return rule.test(this.pasaporte)
    },
    dateOfBirthIsValid () {
      return this.dateOfBirth < new Date().toISOString().substr(0, 10)
    },
    editDNI () {
      this.confirmedDNI = false
      this.confirmedPasaporte = false
      this.firstName = ''
      this.lastName = ''
      this.dateOfBirth = null
      this.photo = null
      this.country = ''
      this.canEdit = true
      this.pasaporte = ''
    },
    editPasaporte () {
      this.confirmedDNI = false
      this.confirmedPasaporte = false
      this.firstName = ''
      this.lastName = ''
      this.dateOfBirth = null
      this.photo = null
      this.country = ''
      this.canEdit = true
      this.dni = ''
    },
    fetchPlayerByDNI () {
      if (!this.dni || !this.dniIsValid()) return
      this.loadingDNI = true
      this.axios
        .get(`player/${this.dni}`)
        .then(response => {
          this.loadingDNI = false
          this.confirmedDNI = true
          this.setData(response.data)
          this.canEdit = false
        })
        .catch(error => {
          if (error && error.response && error.response.status === 404) {
            if (this.dni >= 90000000) {
              this.$refs.newPlayerDialogRef.openDialogNewPlayer()
              this.$emit('click', false)
            } else {
              this.confirmedDNI = true
              this.canEdit = true
            }
          } else {
            this.$store.commit('setErrorMsg', error)
          }
          this.loadingDNI = false
        })
    },
    fetchPlayerByPasaporte () {
      if (!this.pasaporte || !this.pasaporteIsValid()) return
      this.loadingPasaporte = true
      this.axios
        .get(`player/${this.pasaporte}`)
        .then(response => {
          this.loadingPasaporte = false
          this.confirmedPasaporte = true
          this.setData(response.data)
          this.canEdit = false
        })
        .catch(error => {
          if (error && error.response && error.response.status === 404) {
            this.confirmedPasaporte = true
            this.canEdit = true
          } else {
            this.$store.commit('setErrorMsg', error)
          }
          this.loadingPasaporte = false
        })
    },
    searchAlsoByDni () {
      this.confirmedDNI = true
      this.canEdit = true
    },
    newMethodToGoBack () {
      this.$router.go(-1)
    }
  },

  created () {
    this.fetchCountryOptions()

    if (this.isEditing) {
      this.fetchData()
    }
  }
}
</script>

<style scoped>
.content-photo {
  padding: 1.2em 1.5em 2.2em 1.2em;
}
.photo-button {
  width: 100%;
  height: 100%;
  max-height: 275px;
}
.spacing-top {
  margin-top: 6em;
}
</style>
